module.exports = {
      id: "group-usage",
      viewBox: "0 0 11 10",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#group",
      toString: function () {
        return this.url;
      }
    }